module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/top-header-6d030b0d42023eb5.png"+" 2048w",
        images: [{path: __webpack_public_path__ + "assets/images/top-header-6d030b0d42023eb5.png",width: 2048,height: 2048}],
        src: __webpack_public_path__ + "assets/images/top-header-6d030b0d42023eb5.png",
        toString: function(){return __webpack_public_path__ + "assets/images/top-header-6d030b0d42023eb5.png"},
        
        width: 2048,
        height: 2048
      }